<template>
  <NotFoundBlock
    v-if="loaderStore.is404"
    :apiUrl="VITE_RUNTIME_API_URL"
    :soguUrl="VITE_RUNTIME_SOGU_SERVICE_URL"
    :with-subscription-block="true"
  />

  <component
    :is="currentPageContentComponent"
    v-else
  />
</template>

<script setup lang="ts">
  import { NotFoundBlock } from '@experience/site-404-package';
  import { useRuntimeConfig } from 'virtual:runtime-config';
  import { useLoaderStore } from '@/shared/store/useLoaderStore';
  import { useVerticals } from '@/shared/composables/useVerticals.ts';
  import { VerticalsValues } from '@/shared/types/verticals.ts';
  import { useSkeletonPrefetchStore } from '@/shared/store/useSkeletonPrefetchStore.ts';
  import { useListingNotFoundSeo } from '@/pages/listing/composables/useListingNotFoundSeo.ts';

  const { VITE_RUNTIME_API_URL, VITE_RUNTIME_SOGU_SERVICE_URL } = useRuntimeConfig<false>();

  const loaderStore = useLoaderStore();
  const skeletonPrefetchStore = useSkeletonPrefetchStore();
  const route = useRoute();

  const { vertical } = useVerticals();

  const ToursListingPageContent = defineAsyncComponent(() => import('./tour/ToursListingPageContent.vue'));
  const ExcursionListingPageContent = defineAsyncComponent(() => import('./excursion/ExcursionListingPageContent.vue'));

  useListingNotFoundSeo({
    is404: computed(() => loaderStore.is404),
    route,
    vertical,
  });

  watch(
    () => route.path,
    (newPath, oldPath) => {
      if (newPath !== oldPath) {
        skeletonPrefetchStore.clearPrefetchData();
      }
    },
  );

  const currentPageContentComponent = computed(() => {
    switch (vertical.value) {
      case VerticalsValues.TOURS:
        return ToursListingPageContent;
      case VerticalsValues.EXCURSION:
        return ExcursionListingPageContent;
      default:
        // TODO: позже будет дефолтная страница - задача EXP-26202
        return ExcursionListingPageContent;
    }
  });
</script>

<style lang="scss">
  @use '../../../assets/styles/global';
</style>
